module.exports = __webpack_public_path__ + "img/placeholder.de687f69.png";